import { render, staticRenderFns } from "./WeekViewFooter.vue?vue&type=template&id=ebbc2d7c"
import script from "./WeekViewFooter.vue?vue&type=script&lang=js"
export * from "./WeekViewFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports